import { UtensilsCrossed } from 'lucide-react'

export default function LoadingScreen() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-600 to-brand-800 flex items-center justify-center">
      <div className="text-center">
        <UtensilsCrossed className="w-12 h-12 text-white mx-auto mb-4 animate-pulse" />
        <p className="text-brand-100 text-sm">Loading MealMap…</p>
      </div>
    </div>
  )
}
